// extracted by mini-css-extract-plugin
export default {"button":"CustomButton_button__Cmxew","link":"CustomButton_link__fSmbA"};